export const FORGOT_PASSWORD = {
  FORGOT_PASSWORD_REQUEST: "FORGOT_PASSWORD_REQUEST",
  FORGOT_PASSWORD_SUCCESS: "FORGOT_PASSWORD_SUCCESS",
  FORGOT_PASSWORD_FAILURE: "FORGOT_PASSWORD_FAILURE",
  FORGOT_PASSWORD_CLEAR: "FORGOT_PASSWORD_CLEAR",
  RESEND_CODE_REQUEST: "RESEND_CODE_REQUEST",
  RESEND_CODE_SUCCESS: "RESEND_CODE_SUCCESS",
  RESEND_CODE_FAILURE: "RESEND_CODE_FAILURE",
};

// TBD with design - using the middle of the 30-60s range called out in the ticket.
export const FORGOT_PASSWORD_COOLDOWN_SECONDS = 45;